module.exports = __webpack_public_path__ + "logo-light.png?866b7e57a2fc27236413f4663b51dc04";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/light/logo-light.png
// module id = 973
// module chunks = 2